module.exports = __webpack_public_path__ + "static/img/q4.6446f7ef.jpg";